<template>
<div class="page contracts">
  <h1>Mijn contracten</h1>
</div>
</template>

<script>
export default {
name: "Contracts"
}
</script>
